module.exports = __webpack_public_path__ + "fonts/Inter-600-greek-ext59.318d4ba.woff2";